module.exports = __webpack_public_path__ + "img/16.0a93c930.png";